import React, { useEffect } from "react";
import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";

interface Props {
    bodyMsg: string;
    title: string;
    isEng: boolean;
    Visible: boolean;
    field: FormSectionElements;
}

export const SuccessAlertComponent: React.FC<Props> = (props) => {
    const { field, title, Visible } = props;

    useEffect(() => {
        field.Visible = field.InvisibleByDefault !== true;
    }, []);

    useEffect(() => {
        if (typeof Visible === "boolean") {
            if (field.Visible !== false) {
                field.Visible = !field.InvisibleByDefault && Visible;
            }
        }
    }, [Visible]);

    FormValidationUtils.runJavascript(field);

    if (field.Visible === false) {
        return null;
    }

    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    let bodyMsg: any = props.bodyMsg;
    if (/<[a-z][\s\S]*>/i.test(props.bodyMsg)) {
        bodyMsg = htmlToReactParser.parse(props.bodyMsg);
    }

    return (
        <div
            className="ontario-alert ontario-alert--success callout-max-width"
            role="alert"
        >
            <div className="ontario-alert__header" style={{ display: 'flex', alignItems: 'center' }}>
                <div className="ontario-alert__header-icon">
                    <svg
                        className="ontario-icon"
                        aria-hidden="true"
                        focusable="false"
                        viewBox="0 0 24 24"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <use href="#ontario-icon-alert-success"></use>
                    </svg>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h1 className="ontario-alert__header-title ontario-h4">{title}</h1>
                </div>
            </div>
            {bodyMsg && (
                <div className="ontario-alert__body">{bodyMsg}</div>
            )}
        </div>
    );
};
